<template>
  <div class="flex" id="hiring">

    <div class="mx-auto w-5/12 pb-20">

      <section class="mt-32 px-10 md:px-0">

        <h3 class="font-bold text-3xl text-center josefin">Create Your Job Listing</h3>

        <el-form ref="hiringForm" :model="hiringForm">

          <div class="lato mt-6 w-full">

            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 w-full">

              <div>

                <p class="font-bold pb-2">Job Title</p>

                <el-form-item prop="job_title">
                  <el-input style="width: 100%;" v-model="hiringForm.job_title" placeholder="e.g. Physician Advisor"></el-input>
                  <span class="text-red-500 text-xs" v-show="jobTitleCheck">This field is required</span>
                </el-form-item>

              </div>

              <div class="ml-0 md:ml-4">
                <p class="font-bold pb-2">Company Name</p>
                <el-input style="width: 100%;" v-model="company.name" readonly></el-input>
              </div>

            </div>

            <div class="mt-6" id="budget">

              <h3 class="font-bold pb-2">Budget</h3>

              <el-radio-group v-model="hiringForm.rates">
                <el-radio :label="2">Encounter Rate</el-radio>
                <el-radio :label="1">Hourly Rate</el-radio>
                <span class="text-red-500 text-xs" v-show="timeZoneCheck">This field is required</span>
              </el-radio-group>

              <div class="flex flex-col gap-4" v-if="hiringForm.rates === 2">

                <div class="flex mt-5 ml-8">

                  <el-input v-model="hiringForm.encounter_rate" placeholder="$0.00"></el-input>

                  <div class="bg-white border border-gray-200 px-3 flex justify-center items-center text-center" style="border-radius: 0px 8px 8px 0px;">
                    per encounter
                  </div>

                </div>

                <div class="mt-2 flex flex-col ml-8">
                  <span class="text-sm pb-3">On Call Rate</span>
                  <el-input v-model="hiringForm.on_call_rate" placeholder="$0.00"></el-input>
                </div>

              </div>

              <div v-if="hiringForm.rates === 1">

                <div class="flex mt-5 ml-8" >

                  <el-input v-model="hiringForm.hourly_rate" placeholder="$0.00"></el-input>

                  <div class="bg-white border border-gray-200 px-3 flex justify-center items-center text-center" style="border-radius: 0px 8px 8px 0px;">
                    per hour
                  </div>

                </div>

              </div>

            </div>

            <div class="mt-8">

              <h3 class="font-bold pb-2">Preferred Timezone</h3>

              <el-form-item prop="timeZone">

                <el-select style="width: 100%;" v-model="hiringForm.timeZone" placeholder="Pacific Daylight Time (PDT)">

                  <el-option
                      v-for="item in timeZones"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>

                </el-select>

                <span class="text-red-500 text-xs" v-show="timeZoneCheck">This field is required</span>

              </el-form-item>

            </div>

            <div class="mt-8">

              <h3 class="font-bold pb-2">Contract period</h3>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-2 w-full">

                <div class="relative w-full">

                  <p class="font-medium pb-2">Start Date</p>

                  <el-form-item prop="start_date">

                    <el-date-picker
                        style="width: 100%;"
                        v-model="hiringForm.start_date"
                        type="date"
                        placeholder="12/12/2021">
                    </el-date-picker>

                    <span class="text-red-500 text-xs" v-show="startDateCheck">This field is required</span>

                  </el-form-item>

                  <span class="absolute right-4 top-11">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.99992 12.6666C8.13177 12.6666 8.26067 12.6275 8.3703 12.5543C8.47993 12.481 8.56538 12.3769 8.61584 12.2551C8.6663 12.1333 8.6795 11.9992 8.65378 11.8699C8.62805 11.7406 8.56456 11.6218 8.47132 11.5286C8.37809 11.4353 8.2593 11.3718 8.12998 11.3461C8.00066 11.3204 7.86661 11.3336 7.7448 11.384C7.62298 11.4345 7.51886 11.5199 7.44561 11.6296C7.37235 11.7392 7.33325 11.8681 7.33325 12C7.33325 12.1768 7.40349 12.3463 7.52851 12.4714C7.65354 12.5964 7.82311 12.6666 7.99992 12.6666ZM11.3333 12.6666C11.4651 12.6666 11.594 12.6275 11.7036 12.5543C11.8133 12.481 11.8987 12.3769 11.9492 12.2551C11.9996 12.1333 12.0128 11.9992 11.9871 11.8699C11.9614 11.7406 11.8979 11.6218 11.8047 11.5286C11.7114 11.4353 11.5926 11.3718 11.4633 11.3461C11.334 11.3204 11.1999 11.3336 11.0781 11.384C10.9563 11.4345 10.8522 11.5199 10.7789 11.6296C10.7057 11.7392 10.6666 11.8681 10.6666 12C10.6666 12.1768 10.7368 12.3463 10.8618 12.4714C10.9869 12.5964 11.1564 12.6666 11.3333 12.6666ZM11.3333 9.99996C11.4651 9.99996 11.594 9.96086 11.7036 9.8876C11.8133 9.81435 11.8987 9.71023 11.9492 9.58841C11.9996 9.4666 12.0128 9.33255 11.9871 9.20323C11.9614 9.07391 11.8979 8.95512 11.8047 8.86189C11.7114 8.76865 11.5926 8.70516 11.4633 8.67943C11.334 8.65371 11.1999 8.66691 11.0781 8.71737C10.9563 8.76783 10.8522 8.85328 10.7789 8.96291C10.7057 9.07254 10.6666 9.20144 10.6666 9.33329C10.6666 9.5101 10.7368 9.67967 10.8618 9.8047C10.9869 9.92972 11.1564 9.99996 11.3333 9.99996ZM7.99992 9.99996C8.13177 9.99996 8.26067 9.96086 8.3703 9.8876C8.47993 9.81435 8.56538 9.71023 8.61584 9.58841C8.6663 9.4666 8.6795 9.33255 8.65378 9.20323C8.62805 9.07391 8.56456 8.95512 8.47132 8.86189C8.37809 8.76865 8.2593 8.70516 8.12998 8.67943C8.00066 8.65371 7.86661 8.66691 7.7448 8.71737C7.62298 8.76783 7.51886 8.85328 7.44561 8.96291C7.37235 9.07254 7.33325 9.20144 7.33325 9.33329C7.33325 9.5101 7.40349 9.67967 7.52851 9.8047C7.65354 9.92972 7.82311 9.99996 7.99992 9.99996ZM12.6666 1.99996H11.9999V1.33329C11.9999 1.15648 11.9297 0.986912 11.8047 0.861888C11.6796 0.736864 11.5101 0.666626 11.3333 0.666626C11.1564 0.666626 10.9869 0.736864 10.8618 0.861888C10.7368 0.986912 10.6666 1.15648 10.6666 1.33329V1.99996H5.33325V1.33329C5.33325 1.15648 5.26301 0.986912 5.13799 0.861888C5.01297 0.736864 4.8434 0.666626 4.66659 0.666626C4.48977 0.666626 4.32021 0.736864 4.19518 0.861888C4.07016 0.986912 3.99992 1.15648 3.99992 1.33329V1.99996H3.33325C2.80282 1.99996 2.29411 2.21067 1.91904 2.58575C1.54397 2.96082 1.33325 3.46953 1.33325 3.99996V13.3333C1.33325 13.8637 1.54397 14.3724 1.91904 14.7475C2.29411 15.1226 2.80282 15.3333 3.33325 15.3333H12.6666C13.197 15.3333 13.7057 15.1226 14.0808 14.7475C14.4559 14.3724 14.6666 13.8637 14.6666 13.3333V3.99996C14.6666 3.46953 14.4559 2.96082 14.0808 2.58575C13.7057 2.21067 13.197 1.99996 12.6666 1.99996ZM13.3333 13.3333C13.3333 13.5101 13.263 13.6797 13.138 13.8047C13.013 13.9297 12.8434 14 12.6666 14H3.33325C3.15644 14 2.98687 13.9297 2.86185 13.8047C2.73682 13.6797 2.66659 13.5101 2.66659 13.3333V7.33329H13.3333V13.3333ZM13.3333 5.99996H2.66659V3.99996C2.66659 3.82315 2.73682 3.65358 2.86185 3.52855C2.98687 3.40353 3.15644 3.33329 3.33325 3.33329H3.99992V3.99996C3.99992 4.17677 4.07016 4.34634 4.19518 4.47136C4.32021 4.59639 4.48977 4.66663 4.66659 4.66663C4.8434 4.66663 5.01297 4.59639 5.13799 4.47136C5.26301 4.34634 5.33325 4.17677 5.33325 3.99996V3.33329H10.6666V3.99996C10.6666 4.17677 10.7368 4.34634 10.8618 4.47136C10.9869 4.59639 11.1564 4.66663 11.3333 4.66663C11.5101 4.66663 11.6796 4.59639 11.8047 4.47136C11.9297 4.34634 11.9999 4.17677 11.9999 3.99996V3.33329H12.6666C12.8434 3.33329 13.013 3.40353 13.138 3.52855C13.263 3.65358 13.3333 3.82315 13.3333 3.99996V5.99996ZM4.66659 9.99996C4.79844 9.99996 4.92733 9.96086 5.03697 9.8876C5.1466 9.81435 5.23205 9.71023 5.28251 9.58841C5.33296 9.4666 5.34617 9.33255 5.32044 9.20323C5.29472 9.07391 5.23122 8.95512 5.13799 8.86189C5.04475 8.76865 4.92597 8.70516 4.79665 8.67943C4.66733 8.65371 4.53328 8.66691 4.41146 8.71737C4.28965 8.76783 4.18553 8.85328 4.11227 8.96291C4.03902 9.07254 3.99992 9.20144 3.99992 9.33329C3.99992 9.5101 4.07016 9.67967 4.19518 9.8047C4.32021 9.92972 4.48977 9.99996 4.66659 9.99996ZM4.66659 12.6666C4.79844 12.6666 4.92733 12.6275 5.03697 12.5543C5.1466 12.481 5.23205 12.3769 5.28251 12.2551C5.33296 12.1333 5.34617 11.9992 5.32044 11.8699C5.29472 11.7406 5.23122 11.6218 5.13799 11.5286C5.04475 11.4353 4.92597 11.3718 4.79665 11.3461C4.66733 11.3204 4.53328 11.3336 4.41146 11.384C4.28965 11.4345 4.18553 11.5199 4.11227 11.6296C4.03902 11.7392 3.99992 11.8681 3.99992 12C3.99992 12.1768 4.07016 12.3463 4.19518 12.4714C4.32021 12.5964 4.48977 12.6666 4.66659 12.6666Z" fill="#292929"/>
                    </svg>
                  </span>

                </div>

                <div class="ml-0 md:ml-4 relative">

                  <p class="font-medium pb-2">End Date</p>

                  <el-form-item prop="end_date">

                    <el-date-picker
                      style="width: 100%;"
                      v-model="hiringForm.end_date"
                      type="date"
                      placeholder="12/12/2021">
                    </el-date-picker>

                    <span class="text-red-500 text-xs" v-show="endTimeCheck">This field is required</span>

                  </el-form-item>

                  <span class="absolute right-4 top-11">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.99992 12.6666C8.13177 12.6666 8.26067 12.6275 8.3703 12.5543C8.47993 12.481 8.56538 12.3769 8.61584 12.2551C8.6663 12.1333 8.6795 11.9992 8.65378 11.8699C8.62805 11.7406 8.56456 11.6218 8.47132 11.5286C8.37809 11.4353 8.2593 11.3718 8.12998 11.3461C8.00066 11.3204 7.86661 11.3336 7.7448 11.384C7.62298 11.4345 7.51886 11.5199 7.44561 11.6296C7.37235 11.7392 7.33325 11.8681 7.33325 12C7.33325 12.1768 7.40349 12.3463 7.52851 12.4714C7.65354 12.5964 7.82311 12.6666 7.99992 12.6666ZM11.3333 12.6666C11.4651 12.6666 11.594 12.6275 11.7036 12.5543C11.8133 12.481 11.8987 12.3769 11.9492 12.2551C11.9996 12.1333 12.0128 11.9992 11.9871 11.8699C11.9614 11.7406 11.8979 11.6218 11.8047 11.5286C11.7114 11.4353 11.5926 11.3718 11.4633 11.3461C11.334 11.3204 11.1999 11.3336 11.0781 11.384C10.9563 11.4345 10.8522 11.5199 10.7789 11.6296C10.7057 11.7392 10.6666 11.8681 10.6666 12C10.6666 12.1768 10.7368 12.3463 10.8618 12.4714C10.9869 12.5964 11.1564 12.6666 11.3333 12.6666ZM11.3333 9.99996C11.4651 9.99996 11.594 9.96086 11.7036 9.8876C11.8133 9.81435 11.8987 9.71023 11.9492 9.58841C11.9996 9.4666 12.0128 9.33255 11.9871 9.20323C11.9614 9.07391 11.8979 8.95512 11.8047 8.86189C11.7114 8.76865 11.5926 8.70516 11.4633 8.67943C11.334 8.65371 11.1999 8.66691 11.0781 8.71737C10.9563 8.76783 10.8522 8.85328 10.7789 8.96291C10.7057 9.07254 10.6666 9.20144 10.6666 9.33329C10.6666 9.5101 10.7368 9.67967 10.8618 9.8047C10.9869 9.92972 11.1564 9.99996 11.3333 9.99996ZM7.99992 9.99996C8.13177 9.99996 8.26067 9.96086 8.3703 9.8876C8.47993 9.81435 8.56538 9.71023 8.61584 9.58841C8.6663 9.4666 8.6795 9.33255 8.65378 9.20323C8.62805 9.07391 8.56456 8.95512 8.47132 8.86189C8.37809 8.76865 8.2593 8.70516 8.12998 8.67943C8.00066 8.65371 7.86661 8.66691 7.7448 8.71737C7.62298 8.76783 7.51886 8.85328 7.44561 8.96291C7.37235 9.07254 7.33325 9.20144 7.33325 9.33329C7.33325 9.5101 7.40349 9.67967 7.52851 9.8047C7.65354 9.92972 7.82311 9.99996 7.99992 9.99996ZM12.6666 1.99996H11.9999V1.33329C11.9999 1.15648 11.9297 0.986912 11.8047 0.861888C11.6796 0.736864 11.5101 0.666626 11.3333 0.666626C11.1564 0.666626 10.9869 0.736864 10.8618 0.861888C10.7368 0.986912 10.6666 1.15648 10.6666 1.33329V1.99996H5.33325V1.33329C5.33325 1.15648 5.26301 0.986912 5.13799 0.861888C5.01297 0.736864 4.8434 0.666626 4.66659 0.666626C4.48977 0.666626 4.32021 0.736864 4.19518 0.861888C4.07016 0.986912 3.99992 1.15648 3.99992 1.33329V1.99996H3.33325C2.80282 1.99996 2.29411 2.21067 1.91904 2.58575C1.54397 2.96082 1.33325 3.46953 1.33325 3.99996V13.3333C1.33325 13.8637 1.54397 14.3724 1.91904 14.7475C2.29411 15.1226 2.80282 15.3333 3.33325 15.3333H12.6666C13.197 15.3333 13.7057 15.1226 14.0808 14.7475C14.4559 14.3724 14.6666 13.8637 14.6666 13.3333V3.99996C14.6666 3.46953 14.4559 2.96082 14.0808 2.58575C13.7057 2.21067 13.197 1.99996 12.6666 1.99996ZM13.3333 13.3333C13.3333 13.5101 13.263 13.6797 13.138 13.8047C13.013 13.9297 12.8434 14 12.6666 14H3.33325C3.15644 14 2.98687 13.9297 2.86185 13.8047C2.73682 13.6797 2.66659 13.5101 2.66659 13.3333V7.33329H13.3333V13.3333ZM13.3333 5.99996H2.66659V3.99996C2.66659 3.82315 2.73682 3.65358 2.86185 3.52855C2.98687 3.40353 3.15644 3.33329 3.33325 3.33329H3.99992V3.99996C3.99992 4.17677 4.07016 4.34634 4.19518 4.47136C4.32021 4.59639 4.48977 4.66663 4.66659 4.66663C4.8434 4.66663 5.01297 4.59639 5.13799 4.47136C5.26301 4.34634 5.33325 4.17677 5.33325 3.99996V3.33329H10.6666V3.99996C10.6666 4.17677 10.7368 4.34634 10.8618 4.47136C10.9869 4.59639 11.1564 4.66663 11.3333 4.66663C11.5101 4.66663 11.6796 4.59639 11.8047 4.47136C11.9297 4.34634 11.9999 4.17677 11.9999 3.99996V3.33329H12.6666C12.8434 3.33329 13.013 3.40353 13.138 3.52855C13.263 3.65358 13.3333 3.82315 13.3333 3.99996V5.99996ZM4.66659 9.99996C4.79844 9.99996 4.92733 9.96086 5.03697 9.8876C5.1466 9.81435 5.23205 9.71023 5.28251 9.58841C5.33296 9.4666 5.34617 9.33255 5.32044 9.20323C5.29472 9.07391 5.23122 8.95512 5.13799 8.86189C5.04475 8.76865 4.92597 8.70516 4.79665 8.67943C4.66733 8.65371 4.53328 8.66691 4.41146 8.71737C4.28965 8.76783 4.18553 8.85328 4.11227 8.96291C4.03902 9.07254 3.99992 9.20144 3.99992 9.33329C3.99992 9.5101 4.07016 9.67967 4.19518 9.8047C4.32021 9.92972 4.48977 9.99996 4.66659 9.99996ZM4.66659 12.6666C4.79844 12.6666 4.92733 12.6275 5.03697 12.5543C5.1466 12.481 5.23205 12.3769 5.28251 12.2551C5.33296 12.1333 5.34617 11.9992 5.32044 11.8699C5.29472 11.7406 5.23122 11.6218 5.13799 11.5286C5.04475 11.4353 4.92597 11.3718 4.79665 11.3461C4.66733 11.3204 4.53328 11.3336 4.41146 11.384C4.28965 11.4345 4.18553 11.5199 4.11227 11.6296C4.03902 11.7392 3.99992 11.8681 3.99992 12C3.99992 12.1768 4.07016 12.3463 4.19518 12.4714C4.32021 12.5964 4.48977 12.6666 4.66659 12.6666Z" fill="#292929"/>
                    </svg>
                </span>

                </div>

              </div>

            </div>

            <div class="mt-8">

              <h3 class="font-bold pb-2">Shift period</h3>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-2 w-full">

                <div class="relative">

                  <p class="font-medium pb-2">Start Time</p>

                  <el-form-item prop="start_time">

                    <el-time-select
                        style="width: 100%;"
                        v-model="hiringForm.start_time"
                        :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:30'
                    }"
                        placeholder="Select time">
                    </el-time-select>

                    <span class="text-red-500 text-xs" v-show="startTimeCheck">This field is required</span>

                  </el-form-item>

                  <span class="absolute right-4 top-11">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.3332 6.1133C11.2083 5.98913 11.0393 5.91943 10.8632 5.91943C10.6871 5.91943 10.5181 5.98913 10.3932 6.1133L7.99988 8.4733L5.63988 6.1133C5.51498 5.98913 5.34601 5.91943 5.16988 5.91943C4.99376 5.91943 4.82479 5.98913 4.69988 6.1133C4.6374 6.17527 4.5878 6.249 4.55396 6.33024C4.52011 6.41148 4.50269 6.49862 4.50269 6.58663C4.50269 6.67464 4.52011 6.76177 4.55396 6.84301C4.5878 6.92425 4.6374 6.99799 4.69988 7.05996L7.52655 9.88663C7.58853 9.94911 7.66226 9.99871 7.7435 10.0326C7.82474 10.0664 7.91188 10.0838 7.99988 10.0838C8.08789 10.0838 8.17503 10.0664 8.25627 10.0326C8.33751 9.99871 8.41124 9.94911 8.47322 9.88663L11.3332 7.05996C11.3957 6.99799 11.4453 6.92425 11.4791 6.84301C11.513 6.76177 11.5304 6.67464 11.5304 6.58663C11.5304 6.49862 11.513 6.41148 11.4791 6.33024C11.4453 6.249 11.3957 6.17527 11.3332 6.1133Z" fill="#292929"/>
                    </svg>
                  </span>

                </div>

                <div class="relative">

                  <p class="font-medium pb-2">End Time</p>

                  <el-form-item prop="end_time">

                    <el-time-select
                        style="width: 100%;"
                        v-model="hiringForm.end_time"
                        :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:30'
                        }"
                        placeholder="Select time">
                    </el-time-select>

                    <span class="text-red-500 text-xs" v-show="endTimeCheck">This field is required</span>

                  </el-form-item>

                  <span class="absolute right-4 top-11">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.3332 6.1133C11.2083 5.98913 11.0393 5.91943 10.8632 5.91943C10.6871 5.91943 10.5181 5.98913 10.3932 6.1133L7.99988 8.4733L5.63988 6.1133C5.51498 5.98913 5.34601 5.91943 5.16988 5.91943C4.99376 5.91943 4.82479 5.98913 4.69988 6.1133C4.6374 6.17527 4.5878 6.249 4.55396 6.33024C4.52011 6.41148 4.50269 6.49862 4.50269 6.58663C4.50269 6.67464 4.52011 6.76177 4.55396 6.84301C4.5878 6.92425 4.6374 6.99799 4.69988 7.05996L7.52655 9.88663C7.58853 9.94911 7.66226 9.99871 7.7435 10.0326C7.82474 10.0664 7.91188 10.0838 7.99988 10.0838C8.08789 10.0838 8.17503 10.0664 8.25627 10.0326C8.33751 9.99871 8.41124 9.94911 8.47322 9.88663L11.3332 7.05996C11.3957 6.99799 11.4453 6.92425 11.4791 6.84301C11.513 6.76177 11.5304 6.67464 11.5304 6.58663C11.5304 6.49862 11.513 6.41148 11.4791 6.33024C11.4453 6.249 11.3957 6.17527 11.3332 6.1133Z" fill="#292929"/>
                    </svg>
                  </span>

                </div>

              </div>

            </div>

            <div class="mt-8">

              <h3 class="font-bold pb-2">Work Days</h3>

              <span class="text-red-500 text-xs" v-show="workDaysCheck">This field is required</span>

              <el-form-item prop="workdays">

                <el-checkbox-group v-model="hiringForm.workDays">
                  <el-checkbox label="Mon"></el-checkbox>
                  <el-checkbox label="Tue"></el-checkbox>
                  <el-checkbox label="Wed"></el-checkbox>
                  <el-checkbox label="Thu"></el-checkbox>
                  <el-checkbox label="Fri"></el-checkbox>
                  <el-checkbox label="Sat"></el-checkbox>
                  <el-checkbox label="Sun"></el-checkbox>
                </el-checkbox-group>

              </el-form-item>

            </div>

            <div class="my-6">

              <h3 class="font-bold pb-2">Job Description</h3>

              <div>

                <el-form-item prop="content">
                  <span class="text-red-500 text-xs" v-show="jobDescriptionCheck">This field is required</span>
                  <vue-editor v-model="hiringForm.content"></vue-editor>
                </el-form-item>

              </div>

            </div>

            <div class="grid grid-cols-1 gap-2 w-full">
              <div>

                <el-form-item prop="specialty">

                  <p class="font-bold pb-2">Specialties</p>

                  <el-select style="width: 100%;" v-model="hiringForm.specialty" placeholder="Select Specialty" multiple>

                    <el-option
                      v-for="item in specialties"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>

                  </el-select>

                  <span class="text-red-500 text-xs" v-show="workDaysCheck">This field is required</span>

                </el-form-item>

              </div>

            </div>

            <div class="my-6" id="cover_letter">

              <el-checkbox v-model="cover_letter" class="text-black">
                Require a cover letter for the post
              </el-checkbox>

            </div>

            <div id="prompt_letter" v-if="cover_letter">
              <p class="font-bold pb-2">Enter a short prompt for the cover letter</p>
              <el-input v-model="hiringForm.cover_letter_prompt"></el-input>
              <span class="text-red-500 text-xs" v-show="timeZoneCheck">This field is required</span>
            </div>

            <div class="mt-10 flex justify-between flex-col md:flex-row items-center josefin">

              <button @click.prevent="openPreviewModal" class="font-bold text-blue uppercase">Preview</button>
              <button
                @click.prevent="handleSubmit"
                :disabled="isDisabled"
                class="font-bold bg-primary text-white px-12 py-3 text-sm rounded-full"
              >
                {{ loading ? 'Submitting' : 'Post Job' }}
              </button>

            </div>

          </div>

        </el-form>

      </section>

    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="60%">

      <div class="px-4 border-b border-gray-300 pb-4">
        <h3 class="absolute top-7 text-3xl text-black font-semibold josefin">{{ hiringForm.job_title }}</h3>
      </div>

      <section class="flex">

        <div class="w-4/12 flex justify-start items-center flex-col pt-6">

          <img :src="company.logo_url" class="w-40 h-40 rounded-full object-cover"/>

          <h5 class="font-semibold text-xl pt-4 pb-1 text-black josefin">{{ company.name }}</h5>

          <div class="flex items-center">
            <img src="@/assets/img/location.svg" alt="">
            <span class="pl-2 pt-1 text-secondary">{{ company.hq_address }}</span>
          </div>

        </div>

        <div class="w-8/12 py-3 pr-8 lato">

          <h4 class="text-xl fint-semibold text-black josefin">Job Description</h4>

          <div class="flex items-center pt-1 pb-4">

            <div class="bg-lightpurple text-darkPurple font-semibold px-3 py-2 rounded-full">${{ hiringForm.hourly_rate }}/hr</div>

            <div class="bg-gray-100 text-secondary mx-3 px-3 py-2 rounded-full">{{ hiringForm.job_title }}</div>

            <div class="bg-gray-100 text-secondary px-3 py-2 rounded-full">Posted {{ currentDate }}</div>

          </div>

          <p class="text-base" v-html="hiringForm.content"></p>

        </div>

      </section>

    </el-dialog>

  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapActions } from 'vuex'
import { trimUserId } from '@/helpers/functions'
import dayjs from 'dayjs'

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      cover_letter: false,
      company: {
        user_id: '',
        id: '',
      },
      
      specialties: [],
      timeZones: [
        { value: 'pdt', label: 'Pacific Daylight Time (PDT)'},
        { value: 'mdt', label: 'Mountain Daylight Time (MDT)'},
        { value: 'cdt', label: 'Central Daylight Time (CDT)'},
        { value: 'edt', label: 'Eastern Daylight Time (EDT)'},
      ],
      business: [
        { value: 'Option 1', label: 'Option 1'},
        { value: 'Option 2', label: 'Option 2'},
        { value: 'Option 3', label: 'Option 3'},
        { value: 'Option 4', label: 'Option 4'},
      ],
      startTimeCheck: false,
      endTimeCheck: false,
      startDateCheck: false,
      endDateCheck: false,
      workDaysCheck: false,
      timeZoneCheck: false,
      jobDescriptionCheck: false,
      jobTitleCheck: false,
      hiringForm: {
        job_title: '',
        company: '',
        rates: 1,
        encounter_rate: '',
        hourly_rate: '',
        content: '',
        line_of_business: '',
        specialty: '',
        on_call_rate: '',
        timeZone: '',
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: '',
        cover_letter_prompt: '',
        workDays: [],
      }
    }
  },
  computed: {
    currentDate() {
      return (dayjs(new Date()).format('DD MMMM YYYY')) 
    },
    isDisabled() {
      return this.hiringForm.job_title === ""
          || this.hiringForm.content === ""
          || this.hiringForm.specialty === ""
          || this.hiringForm.workDays.length <= 0
          || this.hiringForm.start_date === "" ||
          this.hiringForm.end_date === "" ||
          this.hiringForm.start_time === ""
          || this.hiringForm.end_time === ""
          || this.cover_letter === true &&
          this.hiringForm.cover_letter_prompt === ""
    }
  },
  async created() {
    this.handleFetchSpecialties()
    const payload = {
      user_id: trimUserId(this.$auth.user.sub)
    }
    await this.fetchCompanyProfile(payload)
    .then((res) => {
      this.company = res.data
    })
  },
  methods: {
    ...mapActions([
      'fetchCompanyProfile',
      'createJobPosting',
      'fetchSpecialties'
    ]),
    closePreviewModal() {
      this.dialogVisible = false;
    },
    openPreviewModal() {
      this.dialogVisible = true;
    },
    handleFetchSpecialties() {
      this.fetchSpecialties()
        .then((res) => {
          this.specialties = res.data
        })
    },
    handleSubmit() {
      if(!this.company.id) {
        this.$message.error('Please create a company profile before you can submit a job post!');
      } else {
         this.loading = true
         if(
          this.hiringForm.job_title === ""
          || this.hiringForm.content === ""
          || this.hiringForm.specialty === ""
          || this.hiringForm.workDays.length <= 0
          || this.hiringForm.start_date === "" ||
          this.hiringForm.end_date === "" ||
          this.hiringForm.start_time === ""
          || this.hiringForm.end_time === ""
          ) {
            this.workDaysCheck = true
            this.startTimeCheck = true
            this.endTimeCheck = true
            this.startDateCheck = true
            this.endDateCheck = true
            this.timeZoneCheck = true
            this.jobDescriptionCheck = true
            this.jobTitleCheck = true
            this.loading = false
         } else {
            const payload = {
              job_title: this.hiringForm.job_title,
              poster_user_id: this.company.user_id,
              job_description: this.hiringForm.content,
              company_id: this.company.id,
              specialties: this.hiringForm.specialty,
              start_date: dayjs(this.hiringForm.start_date).format('YYYY-MM-DD'),
              end_date: dayjs(this.hiringForm.end_date).format('YYYY-MM-DD'),
              timezone: this.hiringForm.timeZone,
              shift_start: this.hiringForm.start_time,
              shift_end: this.hiringForm.end_time,
              work_days: this.hiringForm.workDays,
              encounter_rate: this.hiringForm.encounter_rate === "" ? 0 : this.hiringForm.encounter_rate,
              on_call_rate: this.hiringForm.on_call_rate === "" ? 0 : this.hiringForm.on_call_rate,
              hourly_rate: this.hiringForm.hourly_rate === "" ? 0 : this.hiringForm.hourly_rate,
              cover_letter_prompt: this.hiringForm.cover_letter_prompt,
              status: "Open"
            }
            console.log(this.hiringForm.content)
            this.createJobPosting(payload)
              .then((res) => {
                this.$message({
                  message: `${res.data}`,
                  type: 'success'
                });
                this.loading = false
                window.location.reload();
              })
              .catch((err) => {
                this.loading = false
                this.$message.error('Oops, Something went wrong!');
                return err
              })
            }
          }
        
    },
  }
}
</script>

<style scoped>
* >>> .el-input--prefix .el-input__inner {
  padding-left: 10px !important;
  border-radius: 8px !important;
}

* >>> .el-input__prefix {
  opacity: 0;
}

button:disabled,
button[disabled]{
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
</style>